export const TRACKER_SOURCE = 'hofacil-mvp'

const CLICKABLE_SELECTOR = '[data-track],button,a,[role="button"],input[type="submit"],input[type="button"],summary,label'

const TRACKER_SCRIPT = `<script>
(function () {
  var lastKey = ''
  var lastAt = 0

  function clean(value) {
    return value ? String(value).replace(/\\s+/g, ' ').trim() : ''
  }

  function labelOf(el) {
    return clean(el.getAttribute('data-track'))
      || clean(el.getAttribute('aria-label'))
      || clean(el.innerText || el.textContent).slice(0, 80)
      || clean(el.value)
      || clean(el.id)
      || clean(el.getAttribute('name'))
      || el.tagName
  }

  document.addEventListener('click', function (event) {
    try {
      var target = event.target
      var el = target && target.closest ? target.closest('${CLICKABLE_SELECTOR}') : null
      if (!el) {
        return
      }

      var name = labelOf(el)
      var key = name + '|' + el.tagName
      var now = Date.now()
      if (key === lastKey && now - lastAt < 300) {
        return
      }
      lastKey = key
      lastAt = now

      window.parent.postMessage({
        source: '${TRACKER_SOURCE}',
        type: 'click',
        name: name,
        tag: el.tagName,
        explicit: el.hasAttribute('data-track')
      }, '*')
    } catch (e) {}
  }, true)
})()
</script>`

export function injectTracker(html) {
  const content = html || ''
  const anchor = content.match(/<head[^>]*>/i) || content.match(/<html[^>]*>/i)

  if (!anchor) {
    return TRACKER_SCRIPT + content
  }

  const position = anchor.index + anchor[0].length
  return content.slice(0, position) + TRACKER_SCRIPT + content.slice(position)
}
